<template>
    <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
    >
        <v-card v-if="message">
            <v-toolbar
                    dark
                    color="primary"
            >
                <v-btn
                        icon
                        dark
                        @click="closeDialog"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <div v-if="message.chatMessage.chatMessageTypeName === 'Image'">
                    <v-img
                            contain
                            :max-height="imageMaxHeight"
                            :src="messageImgSrc(message)"
                            :lazy-src="imageLoadSrc"
                            @click="showFull"
                    ></v-img>
                </div>
                <div v-else-if="message.chatMessage.chatMessageTypeName === 'Video'">
                    <video-player
                            class="vjs-custom-skin"
                            ref="videoPlayer"
                            :options="playerOptions"
                            :playsinline="true"
                            >
                    </video-player>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import 'video.js/dist/video-js.css'

    import { videoPlayer } from 'vue-video-player'

    export default {
        name: "ChatMultiMediaShow",
        components: {
            videoPlayer
        },
        created(){
            window.VueEvent.listen('show-chat-message-multi-media', this.showDialog);
        },
        data() {
            return {
                dialog: false,
                message: null,
                imageLoadSrc: require('@/assets/loading.svg'),
                imageMaxHeight: '85vh',
                playerOptions: {
                    height: '360',
                    autoplay: true,
                    muted: true,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        // mp4
                        src: this._getMedia('media', this.message),
                        // webm
                        // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                    }],
                    poster: "",
                }
            }
        },
        computed:{
            currentChat() {
                return this.$store.getters.currentChat
            },
        },
        methods:{
            showDialog(message){
                this.message = message
                this.dialog = true
            },
            closeDialog(){
                this.dialog = false
                this.message = null
            },
            messageImgSrc(message){
                return this._getMedia('image', message)
            },
            _getMedia(type, message){
                if(!message){
                    return null
                }
                if(message.localStorage){
                    return `${process.env.VUE_APP_API_PATH}filestorage/activities/${this.currentChat.id}/${type}/${message.localStorage.localFileName}?v=1.0`
                } else {
                    return message.body
                }
            },
            showFull(){
                if(this.imageMaxHeight === '85vh') {
                    this.imageMaxHeight = '100%'
                } else {
                    this.imageMaxHeight = '85vh'
                }
            }
        }
    }
</script>

<style scoped>

</style>